<template>
    <div class="section grey-card">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                <v-col cols="12" class="text-center mb-5">
                    <h1>Integrate with Workflows for Smarter Outreach</h1>
                </v-col>
            </v-row>
            <v-row cols="12" justify="center">
                <v-col cols="12" md="4">
                    <v-card width="100%" class="mb-10 pa-4 fill-height d-flex align-center justify-center flex-column hover-card">
                        <v-card-text><v-icon color="primary" class="d-flex align-center">mdi-alert-circle-outline</v-icon></v-card-text>
                        <v-card-title class="pt-0">
                            Instant Service Alerts
                        </v-card-title>
                        <v-card-text class="text-center">Notify customers the moment an outage occurs across SMS, Email, Voice, or Web Chat.</v-card-text>
                        
                    </v-card>
                </v-col>
                <v-col cols="12" md="4">
                    <v-card class="mb-10 pa-4 fill-height d-flex align-center justify-center flex-column hover-card" width="100%">
                        <v-card-text><v-icon color="primary" class="d-flex align-center">mdi-currency-usd</v-icon></v-card-text>
                        <v-card-title class="pt-0">
                            Automated Payment Reminders
                        </v-card-title>
                        <v-card-text class="text-center">Trigger reminders directly from your CRM or API integrations to reduce overdue invoices.</v-card-text>
                        
                    </v-card>
                </v-col>
            </v-row>
            <v-row cols="12" justify="center">
                <v-col cols="12" md="4">
                    <v-card class="mb-10 pa-4 fill-height d-flex align-center justify-center flex-column hover-card" width="100%">
                        <v-card-text><v-icon color="primary" class="d-flex align-center">mdi-clock-outline</v-icon></v-card-text>
                        <v-card-title class="pt-0">
                            Timely Customer Follow-Ups
                        </v-card-title>
                        <v-card-text class="text-center">Set rules to chase up unresponsive leads after days or weeks, keeping your pipeline warm.</v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="4">
                    <v-card class="mb-10 pa-4 fill-height d-flex align-center justify-center flex-column hover-card" width="100%">
                        <v-card-text><v-icon color="primary" class="d-flex align-center">mdi-form-select</v-icon></v-card-text>
                        <v-card-title class="pt-0">
                            Campaign-Linked Surveys
                        </v-card-title>
                        <v-card-text class="text-center">Launch custom surveys right after a campaign to capture fresh, actionable feedback.</v-card-text>
                        
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'CampaignsWorkflows',
}
</script>

<style lang="scss">


</style>